namespace GeniuzPOS.Product {
    export class CsUnitColumns {
        static columnsKey = 'Product.CsUnit';
    }
}
